<div class="service-dialog">
  
  <div class="dialog-header">
    <h2 mat-dialog-title>
      <mat-icon>{{ isEditMode ? 'edit' : 'add' }}</mat-icon>
      {{ isEditMode ? 'Editar concepto' : 'Añadir concepto' }}
    </h2>
    <button mat-icon-button [mat-dialog-close]="false" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="alert alert-danger alert-dismissible fade show m-3" *ngIf="errorMessage" role="alert">
    <mat-icon>error</mat-icon>
    <span class="ms-2">{{ errorMessage }}</span>
    <button type="button" class="btn-close" (click)="clearError()"></button>
  </div>

  <mat-dialog-content>
    <form [formGroup]="serviceForm" class="service-form">

      <div class="form-section" *ngIf="!isEditMode">
        <h6 class="section-title">
          <mat-icon>store</mat-icon>
          Concepto base del catálogo Handly
        </h6>
        
        <div class="row">
          <div class="col-md-12">
            <app-autocomplete 
              [control]="serviceForm.get('conceptId')" 
              [config]="{
                label: 'Concepto de Handly',
                placeholder: 'Seleccionar concepto...',
                options: data.availableConcepts,
                onChange: onConceptSelected.bind(this)
              }">
            </app-autocomplete>
            <p class="help-text">
              <mat-icon class="info-icon">info</mat-icon>
              Este concepto se usará como base. Puedes personalizar los campos después.
            </p>
          </div>
        </div>
      </div>

      <div class="form-section">
        <h6 class="section-title">
          <mat-icon>visibility</mat-icon>
          Información visible en booking
        </h6>
        
        <div class="row">
          <div class="col-md-12">
            <app-field 
              [control]="serviceForm.get('title')" 
              [config]="{ 
                label: 'Título del concepto', 
                type: 'text',
                required: true,
                helpText: 'Nombre que verán tus clientes al reservar'
              }">
            </app-field>
          </div>

          <div class="col-md-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Descripción del concepto</mat-label>
              <textarea matInput formControlName="description" rows="4" 
                        placeholder="Descripción detallada que verán los clientes"></textarea>
              <mat-hint align="end">{{ serviceForm.get('description').value?.length || 0 }}/1000</mat-hint>
              <mat-error *ngIf="serviceForm.get('description').hasError('maxlength')">
                Máximo 1000 caracteres
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="form-section">
        <h6 class="section-title">
          <mat-icon>settings</mat-icon>
          Configuración operativa
        </h6>
        
        <div class="row">
          <div class="col-md-6">
            <app-field 
              [control]="serviceForm.get('durationMinutes')" 
              [config]="{ 
                label: 'Duración (minutos)', 
                type: 'number',
                required: true,
                helpText: 'Duración del concepto'
              }">
            </app-field>
          </div>

          <div class="col-md-6">
            <app-field 
              [control]="serviceForm.get('price')" 
              [config]="{ 
                label: 'Precio (€)', 
                type: 'number',
                required: true,
                helpText: 'Precio del concepto'
              }">
            </app-field>
          </div>

          <div class="col-md-6">
            <app-field
              [control]="serviceForm.get('bufferBeforeMinutes')"
              [config]="{
                label: 'Margen antes (minutos)',
                type: 'number',
                helpText: 'Tiempo reservado antes del servicio'
              }">
            </app-field>
          </div>

          <div class="col-md-6">
            <app-field
              [control]="serviceForm.get('bufferAfterMinutes')"
              [config]="{
                label: 'Margen después (minutos)',
                type: 'number',
                helpText: 'Tiempo reservado después del servicio'
              }">
            </app-field>
          </div>

          <div class="col-md-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Estado</mat-label>
              <mat-select formControlName="statusMerchantConceptId">
                <mat-option *ngFor="let status of data.conceptStatuses; trackBy: trackByIndex" [value]="status.statusMerchantConceptId">
                  {{ status.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="serviceForm.get('statusMerchantConceptId').hasError('required')">
                El estado es obligatorio
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="form-section">
        <h6 class="section-title">
          <mat-icon>people</mat-icon>
          Personal asignado
        </h6>
        
        <div class="row">
          <div class="col-md-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Staff disponible para este concepto</mat-label>
              <mat-select formControlName="staffUids" multiple>
                <mat-option *ngFor="let staff of data.availableStaff; trackBy: trackByIndex" [value]="staff.id">
                  {{ staff.display }}
                </mat-option>
              </mat-select>
              <mat-hint>Empleados que podrán atender este concepto</mat-hint>
            </mat-form-field>
            
            <p class="staff-hint" *ngIf="!serviceForm.get('staffUids').value || serviceForm.get('staffUids').value.length === 0">
              <mat-icon class="warning-icon">warning</mat-icon>
              Sin personal asignado, este concepto no podrá ser reservado
            </p>
          </div>
        </div>
      </div>

    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <app-button
      label="Cancelar"
      icon="close"
      variant="secondary"
      [disabled]="isLoading"
      (click)="onCancel()">
    </app-button>
    <app-button 
      [label]="isEditMode ? 'Guardar cambios' : 'Añadir concepto'"
      icon="save" 
      variant="primary" 
      [disabled]="serviceForm.invalid || isLoading"
      [loading]="isLoading"
      (click)="onSave()">
    </app-button>
  </mat-dialog-actions>

  <div class="loading-overlay" *ngIf="isLoading">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
  </div>

</div>
